var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-6"},[_c('cupon-extra-info',{attrs:{"icon1":_vm.icon1,"name":_vm.name,"short_description":_vm.short_description,"real_value":_vm.real_value,"beCuponName":_vm.beCuponName,"cupon_description":_vm.cupon_description,"uses_available":_vm.uses_available}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }